import  { useState } from 'react'

export const DashboardState = () => {
    const [loader, setLoader] = useState(true)
    const [lid, setLid] = useState()
    const [inftScroll, setInftScroll] = useState(true)
    const [totalCount, setTotalCount]= useState ({posted: 0, closed : 0, saved : 0, applicant : 0})
    const [applicantCounts, setApplicantCounts]= useState ([])
    const [totalapplicantCounts, setTotalApplicantCounts]= useState ([])
    const [monthlyGraph, setMonthlyGraph] = useState([])
    const [statusGraph, setStatusGraph] = useState({forReview: 0, forInitial : 0, forFinal : 0, forPooling : 0 , rejected : 0 , hired : 0,  reviewed : 0, withdrawn : 0})
    

  return {
    lid:{data: lid, set: setLid},
    loader: {data: loader, set: setLoader},
    inftScroll:{data: inftScroll, set: setInftScroll},
    totalCount: {data: totalCount, set: setTotalCount},
    applicantCounts: {data: applicantCounts, set: setApplicantCounts},
    totalapplicantCounts: {data: totalapplicantCounts, set: setTotalApplicantCounts},
    monthlyGraph:{data: monthlyGraph, set: setMonthlyGraph},
    statusGraph:{data: statusGraph, set: setStatusGraph},
  }
}
